module.exports = {
    api: {
        API_URL: process.env.REACT_APP_API_URL || "https://srv542037.hstgr.cloud:8282/",
    }
}


